import { RPCs } from "../../../services/rpc.js";
import { NoResults } from "../../../components/NoResults/NoResults.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
import { usePaginationState } from "../../../hooks/usePaginationState/index.js";
import { useLocationContext } from "../../Locations/contexts/LocationContext.js";
import { buildLocationServicePeriodQueryArgs, locationAssignedToIds } from "../queries/period-query.js";
import { ServicePeriodScheduleCard } from "./ServicePeriodScheduleCard.js";
import "react";
import { Loading, Pagination } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { RiCalendarScheduleFill } from "react-icons/ri";
//#region src/modules/ServicePeriods/location-panel/ServicePeriodSchedulesList.tsx
function ServicePeriodSchedulesList({ onEditSchedule }) {
	const { location, locationId } = useLocationContext(true);
	const { recordsPerPage, setRecordsPerPage, setSkippedRecords, skippedRecords } = usePaginationState(`locsvcper_${locationId}_periods`, { defaultRecordsPerPage: 25 }, []);
	const assignedToIds = locationAssignedToIds(locationId, location.locationGroupIds);
	const periods = useRPC(RPCs.ServicePeriods.FindServicePeriods.v1, buildLocationServicePeriodQueryArgs({
		assignedToIds,
		pagination: {
			limit: recordsPerPage,
			skip: skippedRecords
		}
	}));
	const rows = periods.data?.servicePeriods ?? [];
	const total = periods.data?.total ?? 0;
	return /* @__PURE__ */ jsxs("div", {
		className: "relative mt-xs",
		children: [
			/* @__PURE__ */ jsx(Loading, {
				overlay: true,
				size: "xxl",
				visible: periods.isCalling && !rows.length
			}),
			!periods.isCalling && periods.success && !rows.length && /* @__PURE__ */ jsx(NoResults, {
				iconName: RiCalendarScheduleFill,
				text: "No service periods"
			}),
			!!rows.length && /* @__PURE__ */ jsx("div", {
				className: "flex flex-col gap-sm",
				children: rows.map((period) => /* @__PURE__ */ jsx(ServicePeriodScheduleCard, {
					locationId,
					onEdit: onEditSchedule,
					period
				}, period.id))
			}),
			total > 0 && /* @__PURE__ */ jsx("div", {
				className: "my-base",
				children: /* @__PURE__ */ jsx(Pagination, {
					onPageClick: setSkippedRecords,
					onSetRecordsPerPage: setRecordsPerPage,
					recordsPerPage,
					showDescription: true,
					skippedRecords,
					totalRecords: total
				})
			})
		]
	});
}
//#endregion
export { ServicePeriodSchedulesList };

//# sourceMappingURL=ServicePeriodSchedulesList.js.map